import { useMemo } from 'react';
import { store } from 'Utilities/store';
import useLegacyCaregiver from './useLegacyCaregiver';
import useLibreCaregiver from './useLibreCaregiver';
const hookByApp = {
  libre1: {
    useCaregiver: useLibreCaregiver
  },
  default: {
    useCaregiver: useLegacyCaregiver
  }
};

/**
 * This hook serves as a temporary solution to maintain the current implementation for partners
 * (e.g., Insulet and CommercialAPI) while enabling the Libre app to use its own API endpoints.
 *
 * For the Libre app, it utilizes the Libre API endpoints. Once the migration to lsapi endpoints
 * is complete, this hook will be deprecated, and all requests will be directed to the new endpoints.
 *
 * The primary goal of this hook is to ensure that the existing partner implementations remain
 * unchanged during the transition period.
 */

const useMainCaregiver = () => {
  const {
    env: {
      app
    }
  } = store.getState();
  const {
    useCaregiver
  } = useMemo(() => app === 'libre1' ? hookByApp.libre1 : hookByApp.default, [app]);
  const caregiverHook = useCaregiver();
  return {
    ...caregiverHook
  };
};
export default useMainCaregiver;